import { Component, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { NavigationService } from 'src/app/core/api/navigation.service';
import { PatientService } from 'src/app/core/api/patient.service';
import { patientSideNavSchema } from 'src/app/core/schemas/navigation-schema';
import { AppStateService } from 'src/app/core/services/app-state.service';
import { StaffPermissionsService } from 'src/app/core/services/staff-permissions.service';
import { LoadingSpinnerService } from 'src/app/shared/loading-spinner/loading-spinner.service';
import { EConsultFormGroup } from '../../econsult/econsult-form.model';
import { TabletQuestionnaireModalComponent } from '../../shared/tablet-questionnaire-modal/tablet-questionnaire-modal.component';
import { EncountersRoutes } from '../encounters.routes';
import { SelectAssessmentsModalComponent } from '../select-assessments-modal/select-assessments-modal.component';
import {
  QuestionnaireRequest,
  SendQuestionnaireDialogData
} from 'src/app/core/api/questionnaire-request.service';
import { SideSheetService } from 'src/app/shared/side-sheet/side-sheet.service';
import { AssessmentService } from './../../core/api/assessment.service';
import { SendQuestionnaireDialogComponent } from './../../shared/send-questionnaire-dialog/send-questionnaire-dialog.component';
import {
  EncountersCompareModalComponent,
  EncountersToCompare
} from './../encounters-compare-modal/encounters-compare-modal.component';
@Component({
  selector: 'csi-encounter-dashboard',
  templateUrl: './encounter-dashboard.component.html',
  styleUrls: ['./encounter-dashboard.component.scss'],
  providers: [AssessmentService, EConsultFormGroup]
})
export class EncounterDashboardComponent implements OnInit {
  EncountersRoutes = EncountersRoutes;
  assessmentIdToExpand: string;
  assessmentRowHoveredId: string;
  encountersToCompare: EncountersToCompare = [];
  treatmentPicker: any;
  isLoading: boolean;
  invoices: any[] = [];
  translocoFileKey = 'dashboard.patients-dashboard.';

  constructor(
    public router: Router,
    public route: ActivatedRoute,
    public patientService: PatientService,
    public appStateService: AppStateService,
    public staffPermissionsService: StaffPermissionsService,
    public loadingSpinnerService: LoadingSpinnerService,
    private dialog: MatDialog,
    public formGroup: EConsultFormGroup,
    private navigationService: NavigationService,
    private snackBar: MatSnackBar,
    private sideSheetService: SideSheetService
  ) {}
  ngOnInit() {
    this.navigationService.updateSideNavSchema(patientSideNavSchema);
    if (
      this.patientService.patient &&
      this.patientService.patient.clinic &&
      this.patientService.patient.clinic.id
    ) {
      const filter = { treatmentPlanClinicId: { eq: this.patientService.patient.clinic.id } };
    }
  }

  openTabletQuestionnaire() {
    TabletQuestionnaireModalComponent.open(this.dialog, null, this.patientService.patient)
      .afterClosed()
      .subscribe(questionnaireRequestGenerated => {
        if (questionnaireRequestGenerated) {
          this.patientService.questionnaires = [
            questionnaireRequestGenerated,
            ...this.patientService.questionnaires
          ];
        }
      });
  }
  openSendQuestionnaire() {
    this.sideSheetService
      .open<
        SendQuestionnaireDialogComponent,
        SendQuestionnaireDialogData,
        QuestionnaireRequest | QuestionnaireRequest[]
      >(
        SendQuestionnaireDialogComponent,
        SendQuestionnaireDialogComponent.buildDialogData(
          null,
          this.appStateService.getCurrentPatient(),
          null,
          true,
          true
        )
      )
      .afterClosed()
      .subscribe(questionnaireRequestsSent => {
        if (!questionnaireRequestsSent) {
          return;
        }
        const sentQuestionnaireRequests = Array.isArray(questionnaireRequestsSent)
          ? questionnaireRequestsSent
          : [questionnaireRequestsSent];
        this.patientService.questionnaires = [
          ...sentQuestionnaireRequests,
          ...this.patientService.questionnaires
        ];
      });
  }
  openEncountersCompare() {
    var MAX = 4;
    var selected = this.encountersToCompare || [];

    if (selected.length > MAX) {
      var ref = this.dialog.open(SelectAssessmentsModalComponent, {
        width: '520px',
        data: {
          currentCompared: selected,
          unaddedAssessments: [],
          maxSelectable: 0
        }
      });

      ref.afterClosed().subscribe((updated: any) => {
        if (updated && updated.length) {
          this.encountersToCompare = updated;
          if (updated.length <= MAX) {
            EncountersCompareModalComponent.open(
              this.dialog,
              this.encountersToCompare,
              this.snackBar
            );
          }
        }
      });
      return;
    }

    EncountersCompareModalComponent.open(this.dialog, selected);
  }
  routeToNewEncounter() {
    this.router.navigate([{ outlets: { encounters: EncountersRoutes.New } }], {
      relativeTo: this.route.parent
    });
  }
}
